module.exports = __webpack_public_path__ + "static/legends-3-c791aab503f933b71071f099b9409797.jpg";